import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { COREAPI } from '../../constants/global';

// Single RTK Query slice for the app. Feature modules add their endpoints via
// `baseApi.injectEndpoints(...)` (see ./observer-api.ts) rather than creating
// their own `createApi` — one reducer + one middleware for all of them.
//
// This coexists with the convention-based thunk store (src/store/actions/**),
// it does not replace it. Use it for feature-scoped calls that must NOT touch
// the main session: there is no Bearer/PartyId header and no 401 -> logout
// here, and non-2xx bodies come back as `error.data` instead of throwing,
// which is what the public onboarding endpoints need to read their error
// `code`. Session-bound calls stay on the thunk helpers.
//
// `reducerPath: 'api'` is deliberate: the convention reducer in
// src/store/reducers/rootreducer.ts routes any action whose type *contains*
// a domain namespace (`_auth`, `_kyc`, ...). RTK Query's action types look
// like `api/executeMutation/fulfilled` — no underscore-prefixed segment — so
// they can never be captured by a domain slice. Keep the path free of
// underscores if it is ever renamed.
//
// The timeout is the one bound on a request in this app; the thunk helpers
// send `timeout: 0` (= none) and a dropped socket hangs forever.
export const API_REQUEST_TIMEOUT_MS = 20_000;

export const baseApi = createApi({
	reducerPath: 'api',
	baseQuery: fetchBaseQuery({
		baseUrl: COREAPI,
		timeout: API_REQUEST_TIMEOUT_MS,
	}),
	endpoints: () => ({}),
});
